import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { LoadingService } from '../../services/util/loading.service';
import { OfficeService } from '../../services/office.service';
import { MatSnackBar } from '@angular/material/snack-bar';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: [],
})
export class FullComponent implements OnDestroy {
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;
  sectionalTypes: any[] = [];
  sectionalType: any = {};

  constructor(private loadingService: LoadingService, private officeService: OfficeService, private changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private snackBar: MatSnackBar, public menuItems: MenuItems) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.getAllSectionalTypes();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  snackBarMessage(msg: any, duration: any) {
    this.snackBar.open(msg, '', {
      duration: duration, panelClass: ['purple-snackbar']
    });
  }

  request() {
    return this.loadingService.mustShowSpinner();
  }

  getAllSectionalTypes() {
    this.officeService.getAllSectionalTypes().subscribe((response: any) => {
      this.sectionalTypes = response;
      if (localStorage.getItem('currentSectionalType')) {
        this.sectionalType = JSON.parse(localStorage.getItem('currentSectionalType')).id ? JSON.parse(localStorage.getItem('currentSectionalType')) : { id: '', name: 'Todos' };
      } else {
        this.sectionalType = { id: '', name: 'Todos' };
      }
    }, (e: any) => {
      if (e.status === 409) {
        this.snackBarMessage(e.error.message, 5000);
      } else {
        this.snackBarMessage('Ocurrio un problema', 5000);
      }
    });
  }

  changeSectionalType(type: any) {
    localStorage.setItem('currentSectionalType', JSON.stringify(type));
  }
}
